import {createSlice} from '@reduxjs/toolkit';

const frameworkSlice = createSlice({
  name: 'framework',
  initialState: {
    sidebarOpen: false,
    // Seeded from the real width (same 767px breakpoint Framework applies). Starting at `false`
    // rendered every phone load as desktop for one commit, then swapped layouts - unmounting
    // whatever the desktop branch had started, e.g. Cropview's Google Maps loader mid-load.
    smallScreen: typeof window !== 'undefined' && window.innerWidth <= 767,
  },
  reducers: {
    updateSidebarOpen(state, action) {
      state.sidebarOpen = action.payload;
    },
    updateSmallScreen(state, action) {
      state.smallScreen = action.payload;
    },
  },
});

export const {updateSidebarOpen, updateSmallScreen} = frameworkSlice.actions;
export default frameworkSlice.reducer;
